import React, { useState, useEffect } from 'react';

export const ToggleButton = (props) => {
  const [isOff, setisOff] = useState(props.isToggled);

  const handleClick = () => {
    props.onToggle();
    // setisOff(!isOff);
  };

  useEffect(() => {
    setisOff(!isOff);
  }, [props.isToggled]);

  return (
    <button
      style={{
        backgroundColor: isOff ? '#dc3545' : '#28a745',
        color: 'white',
        padding: '7px 12px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      {isOff ? 'Off' : 'On'}
    </button>
  );
}